export default __webpack_public_path__ + "static/media/adminIcon.5460028d.png";